import { ReactNode, useState } from 'react'
import { useEffectOnce } from 'react-use'
import { BannerVariant } from '@getgo/chameleon-core/next'
import { useLocalStorage } from '@rehooks/local-storage'
import { emitChange } from '@ucc/admin-global-state'
import { useMessaging } from '@ucc/admin-messaging'

import config from 'config'

export interface GlobalBanner {
  id: string
  createdAt: number
  closeable?: boolean
  content?: ReactNode
  variant?: BannerVariant
}

const useBanners = (): { banners: GlobalBanner[]; removeBanner: (id) => void } => {
  const [dismissedBanners, setDismissedBanners] = useLocalStorage<string[]>(config.DISMISSED_BANNERS, [])
  const [banners, setBanners] = useState<GlobalBanner[]>([])
  const isBannerDisplayed = !!banners.length

  useMessaging('bannerNotification', (payload: unknown) => {
    const bannerInfo = payload as GlobalBanner
    if (bannerInfo && !dismissedBanners.includes(bannerInfo.id)) {
      setBanners((currentBanners) => [
        ...currentBanners,
        {
          ...bannerInfo,
          createdAt: Date.now(),
        },
      ])
    }
  })

  useEffectOnce(() => {
    emitChange((prev) => ({ ...prev, isBannerDisplayed }))
  })

  const removeBanner = (idToRemove) => {
    setBanners((currentBanners) => currentBanners.filter(({ id }) => id !== idToRemove))
    setDismissedBanners([...dismissedBanners, idToRemove])
  }

  return { banners, removeBanner }
}

export default useBanners
